import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextModule } from 'angular-i18next';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import {
  faCloudArrowUp,
  faFile,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DeleteDialogComponent } from '../delete-dialog/dialog.component';

export interface Attachment {
  id: string;
  label: string;
  file: {
    fileName: string;
    signedUrl: string;
  };
}

export type AttachmentAction =
  | { action: 'add'; attachments: File[] }
  | { action: 'remove'; attachmentId: string };

export enum FileType {
  TXT = '.txt',
  CSV = '.csv',
  JPG = '.jpg',
  JPEG = '.jpeg',
  PNG = '.png',
  DOCX = '.docx',
  XLSX = '.xlsx',
  PPTX = '.pptx',
  PDF = '.pdf',
  AVI = '.avi',
  MP4 = '.mp4',
  MPEG = '.mpeg',
  OGV = '.ogv',
  WEBM = '.webm',
  MOV = '.mov',
}

export const ALL_FILE_TYPES = Object.values(FileType);

@Component({
  selector: 'fo-file-upload',
  templateUrl: './template.html',
  styleUrls: ['./style.scss'],
  imports: [MaterialModule, I18NextModule, FontAwesomeModule],
})
export class FileUploadComponent {
  @Input() disabled = false;
  @Input({ required: true }) attachments: Attachment[];
  @Input({ required: true }) acceptedFileTypes: FileType[];

  get acceptString(): string {
    return this.acceptedFileTypes.join(', ');
  }
  @Output() newAttachmentsChange: EventEmitter<AttachmentAction> =
    new EventEmitter();

  faCloudArrowUp = faCloudArrowUp;
  fileIcon = faFile;
  crossIcon = faXmark;

  constructor(private dialog: MatDialog) {}

  protected attach(ev: Event) {
    const newFileList = [];
    const addedFiles = (ev.target as HTMLInputElement).files;
    for (let i = 0; i < addedFiles.length; i++) {
      newFileList.push(addedFiles[i]);
    }
    this.newAttachmentsChange.emit({
      attachments: newFileList,
      action: 'add',
    });
  }

  protected detach(id: string) {
    const dialogRef = this.dialog.open<DeleteDialogComponent, never, boolean>(
      DeleteDialogComponent,
    );
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.newAttachmentsChange.emit({ action: 'remove', attachmentId: id });
      }
    });
  }

  isImg(fileName: string) {
    const imgExt = ['png', 'jpg', 'jpeg'];
    return imgExt.some((ext) => fileName.endsWith(ext));
  }

  openDialog(image: Attachment) {
    this.dialog.open(ImageDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '96%',
      width: '96%',
      data: {
        imageUrl: image.file.signedUrl,
        file: image,
        title: image.file.fileName,
      },
    });
  }
}
